import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiCompanyService
} from "src/app/shared/service";
import {
    DtgActionType
    ,dtgCarTypeList
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.manage.company.modal.delete.component.html"
    ,styleUrls: ["./dtg.manage.company.modal.delete.component.scss"]
    ,providers: []
})
export class DtgManageCompanyModalDeleteComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    dtgCarTypeList = dtgCarTypeList;
    @Input() companyInfo:any;

    constructor(
        private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
        ,public activeModal: NgbActiveModal
    ) {

    }

    ngOnInit() {}

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    clickSave(){
        this.activeModal.close({
            "result":"ok"
        });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }
}